import _Symbol$for from "@babel/runtime-corejs3/core-js/symbol/for";
import React from "react";
var $counter = _Symbol$for('@xo-union/ui-accessibility/useDescriptionNode--counter');
var useDescriptionNode = function useDescriptionNode(id, description) {
  React.useEffect(function () {
    var node = document.getElementById(id);
    if (!node) {
      node = document.createElement('div');
      node.style.display = 'none';
      node.setAttribute('aria-hidden', 'true');
      document.body.appendChild(node);
      node.setAttribute('id', id);
      node.textContent = description;
    }
    node[$counter] = node[$counter] || 0;
    node[$counter] += 1;
    return function () {
      node[$counter] -= 1;
      if (node[$counter] === 0) {
        document.body.removeChild(node);
      }
    };
  }, [id, description]);
};
export default useDescriptionNode;